import template from './area-land.jade';
import validation from '../../../services/validation';
import areaUnits from '../../../enums/area-units';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.commonAreaLand', []).directive('cianAfCommonAreaLand', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'deviceService',
    'store',
    'config',
    function (deviceService, store) {
      this.isMobile = deviceService.isMobile;
      this.areaUnitOptions = areaUnits;

      if (!this.ad.land) {
        this.ad.land = {};

        if (!this.ad.land.areaUnitType) {
          this.ad.land.areaUnitType = this.areaUnitOptions[0].key;
        }
      }

      this.areaMax = 10000000;
      this.areaMin = 0;

      this.validationArea = validation(this.form, 'areaLandValue', {
        parse: 'Введите число',
        min: 'Площадь должна быть больше 0',
        max: 'Допустимо не более 7 символов',
        required: 'Укажите площадь участка',
      });

      this.validationUnit = validation(this.form, 'land.areaUnitType', {
        required: 'Укажите единицы измерения',
      });

      let trackedValue;

      this.handleBlur = () => {
        const value = this.ad.land.area;

        if (value && value !== trackedValue) {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'land_area');
          trackedValue = value;
        }
      };
    },
  ],
  controllerAs: 'areaLand',
  template,
})).name;
